module Web.HTML.Event.HashChangeEvent.EventTypes where

import Web.Event.Event (EventType(..))

hashchange :: EventType
hashchange = EventType "hashchange"
